import getGraphQlClient from '~graphql/getGraphQlClient';
import {
  FETCH_CLIENTI_BY_DEFUNTO_JOIN,
  FETCH_DELEGANTI,
  FETCH_DELEGANTI_BY_DEFUNTO_JOIN,
} from '../queries/deleganti';
import { onErrorShowMessage } from '~src/errors';
import { unmarshalGraphqlResponse } from '~graphql/utils';

export const fetchDeleganti = async (where, showError = true) => {
  try {
    const graphQlClient = await getGraphQlClient();

    const result = await graphQlClient.query({
      variables: {
        where,
      },
      query: FETCH_DELEGANTI,
    });

    const deleganti = await unmarshalGraphqlResponse(result.data, 'famigliaris')
      .edges;

    return deleganti;
  } catch (error) {
    if (showError) {
      onErrorShowMessage();
    }
    console.error(error);
  }
};

export const fetchDelegantiByDefuntoJoin = async (where) => {
  try {
    const graphQlClient = await getGraphQlClient();

    const result = await graphQlClient.query({
      variables: {
        where,
      },
      query: FETCH_DELEGANTI_BY_DEFUNTO_JOIN,
      fetchPolicy: 'network-only',
    });

    const joins =
      unmarshalGraphqlResponse(result.data, 'join_famigliari_defuntos').edges ||
      [];

    return joins
      .filter((join) => join.famigliari_pointer)
      .map((join) => ({
        ...join.famigliari_pointer,
        grado_parentela: join.grado_parentela,
        joinObjectId: join.objectId,
        principale: join.principale,
        stato: join.stato,
      }));
  } catch (error) {
    console.error(error);
    return [];
  }
};

export const fetchClientiByDefuntoJoin = async (where) => {
  try {
    const graphQlClient = await getGraphQlClient();

    const result = await graphQlClient.query({
      variables: {
        where,
      },
      query: FETCH_CLIENTI_BY_DEFUNTO_JOIN,
      fetchPolicy: 'network-only',
    });

    const joins =
      unmarshalGraphqlResponse(result.data, 'join_clienti_defuntos').edges ||
      [];

    return joins
      .filter((join) => join.cliente_pointer)
      .map((join) => ({
        ...join.cliente_pointer,
        joinObjectId: join.objectId,
      }));
  } catch (error) {
    console.error(error);
    return [];
  }
};
